import script from "./AppointmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__